









































































































//import { User } from '@/modules/auth/types'
import { Colors, notify } from '@/modules/core/notification'
import User from '@/modules/user/model/User'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Ref, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'
import * as api from '@/modules/app-router/api'
import _, { isUndefined } from 'lodash'
import RegisterPlatformUserData from '@/modules/app-router/model/RegisterPlatformUser'
import { VForm } from '@/types'
import {loadModule} from '@/store'
import ApiVersionSelect from '@/modules/app-router/components/ApiVersion/ApiVersionSelect.vue'
import { log } from 'autobahn'
import { updateDepartmentType } from '@/modules/reservation/api'
/**
 * Dialogo para registrar un usuario en la plataforma de Unigest
 */
@Component({
    components: {
        ApiVersionSelect
    }
})
export default class RegisterPlatformUser extends Vue {
    /**
     * Controla la visibilidad del estado
     */
    @Prop({ type: Boolean, default: false }) 
    public value: boolean
    

    @Prop({default: '' }) 
    public urlapi: string

    @Prop({default: '' }) 
    public pass: string

    @Ref('form')
    form: VForm

    @State(state => state.user.currentUser)
    public user: User

    public roles = ['Administrador','Usuario']
    public loading = false
    public idEmpresaPartial  =''
    public idEmpresaOld = ''
    private serialCurrent = 'dddddd'
    private isIni = true
    private dataCurrent =  new RegisterPlatformUserData()
    private saving = false
    public dataResultOperation = ''
    public isOperationOk = false
    public companiesCurrent = new Array<string>()
    public isNotAsignatedPassword = false;
    private idUriApiCurrent = 0
    

    /**
     * Reglas de validación para el formulario de registro del usuario en Unigest
     */
    public rules = {
        // Reglas de validación para el campo "rol de usuario"
        role: [
            (v: any) => !!v || 'El rol es obligatorio'
        ],
        password: [
            (v: string) => !!v || 'La contraseña es obligatoria'
        ]
        //,idEmpresaPartial:[(v: string) => (!!v && this.dataCurrent.isCreateCompany) || 'Nombre empresa es obligatoria']
    }
    
    public get serialNumber(): string {
        return this.serialCurrent;
    }

    async created() {
        await loadModule('appRouter')
        
    }

    @Watch('value')
    async watchValue (value: boolean) {
        if (!value) {
            return
        }

        await this.$store.dispatch('appRouter/loadApis')
        const api = this.$store.state.appRouter.apis[0] 
        if (!api) {
            return
        }

        this.$store.commit('appRouter/SET_CURRENT_API', api)
    }

    async beforeUpdate() {
        if(!this.value){
         this.isIni = true
            return
        }
        
        if(this.isIni){
            this.isIni = false
        } else {
            return
        }
        this.dataResultOperation = ''
        if(this.user.groups.length > 0 && this.user.groups[0].attributes && this.user.groups[0].attributes.SERIAL_NUMBER){
            this.serialCurrent = this.user.groups[0].attributes.SERIAL_NUMBER || ''
        }
        if(this.serialCurrent.length <= 4){
            this.$emit('value',false) // -> this.value = false;
            throw new Error('Debe de asingar un numero serie al usuario.')
            return;
        }
        this.setData()
        this.dataCurrent.serial = this.serialCurrent
        this.isOperationOk = false
        if(!this.dataCurrent.isCreateCompany) {
            this.dataCurrent.idEmpresa = ''
        } 
        
        if(this.dataCurrent.isCreateCompany || this.companiesCurrent.length > 0 ){
            return
        }
        if(!this.dataCurrent.isCreateCompany){
            await  this.onChageApisVersionSelect()
            if(!this.companiesCurrent || (this.companiesCurrent && this.companiesCurrent.length === 0) ){
                this.dataCurrent.isCreateCompany = true;
            }
        }
    }

    /**
     * Define un attributo en el usuario
     */
    setAttribute(key: string, value: any) {
        this.$store.commit('user/SET_USER_ATTRIBUTE', {key, value})
    }

    async onClose(tipo: number){
        const self = this;
        if(tipo == 0 && this.user.attributes.idEmpresa !== undefined){
            this.$emit('confirmed',tipo)   
            this.$emit('value',false) // ->this.value = false;      
            setTimeout(()=>self.isIni = true, 200);
  /*       } else if (tipo == 1) {
            if (!this.form.validate()) {
                return
            }
           const r =  this.registrar() */
        } else {
            this.$emit('confirmed',tipo)
            this.$emit('input', false)
            setTimeout(()=>self.isIni = true, 200);
        }
       
    }

    async registrar(){
        this.onHidenResult()
        if (!this.form.validate()) {
                return
        }
        // Validar datos antes.
        var resul = this.validarData();

        if(this.validarData().length > 0){
            notify(resul, Colors.Error)
            return
            // throw new Error(resul)
        }
        if(!this.saving) {
            // Asignar datos al estado
            this.setDataState()
            // Llamar al servicio registras usuario.
            const result = await this.saveRegister()
            this.saving = false;
            if(result === 0) return
            this.isOperationOk = true;
            this.$emit('confirmed', 2)    
        } 
    }

    validarData(): string {
        var resul = '';
        var idEmpresa = this.dataCurrent.idEmpresa || ''
        /* // Validar que el id de empresa es válido
        if(this.dataCurrent.isCreateCompany && (idEmpresa === undefined || idEmpresa === null)){
            resul = 'Id empresa no puede ser blaco o nulo'
        } */

        // Validar que el nombre empresa es válido se se pretender crearla
        if(this.dataCurrent.isCreateCompany && idEmpresa.length < 6){
            resul = 'Nombre empresa no es válido'
            return resul;
        }

        // Validar que el nombre empresa es válido se se pretender crearla
        if(this.dataCurrent.password.length < 4){
            resul = 'Clave no es válido, debe de ser superior de 3 caracteres.'
            return resul;
        }
        
        // Validar que tenga un rol asignado
        if(this.dataCurrent.role === undefined || this.dataCurrent.role.length < 2){
            resul = 'Debe de asignar al usuario un rol.'
            return resul;
        }


         // Validar que tenga una url asignado
        if(this.dataCurrent.apiURL === undefined || this.dataCurrent.apiURL.length < 5){
            resul = 'Debe de asignar una Url válida para la Api.'
            return resul;
        }

        // Validar que tenga un idEmpresa (nombre de la Bbdd empresa)
        if(this.dataCurrent.idEmpresa === undefined || this.dataCurrent.idEmpresa.length < 1){
            resul = 'Debe de asignar una empresa donde registrarse el usuario,'
            return resul;
        }
        if(this.dataCurrent.idEmpresa.length < 10){
            resul = 'Debe de asignar un nombre empresa con un formato válido p. e. NNNN_XXXXXX y mayor de 10 caracteres'
            return resul;
        }
        
        return resul
    }

    onChageSwitchCrearEmpresa(value: boolean){
        if(!value){
            this.dataCurrent.idEmpresa = '' // this.setAttribute('idEmpresa', '')
            this.idEmpresaPartial = '';
            this.onChageApisVersionSelect() // antes -> this.onChageApisVersionSelect(this.idUriApiCurrent)
        } else if( this.idEmpresaPartial === undefined || this.idEmpresaPartial.length === 0){
            this.idEmpresaPartial = new Date().getFullYear().toString()
            this.setNameCompanyFull(this.idEmpresaPartial)
        }
    }

    onChageSwitchRool(value: string){}

    public canAceptar(): boolean{
        return (this.isOperationOk && this.isFieldOK(this.dataCurrent.idEmpresa) 
                && this.isFieldOK(this.dataCurrent.apiURL) 
                && this.isFieldOK(this.dataCurrent.role))
    }

    private isFieldOK(value: string){
        return (value !== undefined && value.length > 0);
    }
    /**
     * Guardar cambios del usuario
     */
    public async saveRegister (): Promise<number>{
        let result = 1
        try {
            this.loading = true 
            this.$emit('loading', this.loading)
            this.saving = true
            /* const id = this.user.id;
            const passaword = this.dataCurrent.password
            const role = (this.dataCurrent.role === this.roles[0]) ? 1 : 2
            const isCreateCompany = this.dataCurrent.isCreateCompany
            const idEmpresaPartial =  this.dataCurrent.idEmpresa */
            this.dataCurrent.idUser = this.user.id
            this.dataCurrent.roleType = (this.dataCurrent.role === this.roles[0]) ? 1 : 2
            this.dataCurrent.apiURL = this.urlapi;
            const dataResult = await api.registerPlatformUser(this.dataCurrent) //passaword, role, isCreateCompany, idEmpresaPartial, this.dataCurrent.apiURL)
            result =  this.processResult(dataResult) ? 1 : 0
        } catch (error) {
            result = 0
          notify(error.message, Colors.Error)
            throw new Error(_.get(error, 'response.data.message', error.message))
        } finally {
            this.saving = false
            this.loading = false 
            this.$emit('loading', this.loading)
        }

        return result
    }

    private setDataState(){
        this.setAttribute('registroPlataforma', true)
        this.setAttribute('serie', this.dataCurrent.serial)
        this.setAttribute('idEmpresa', this.dataCurrent.idEmpresa)
        this.setAttribute('crearEmpresa', this.dataCurrent.isCreateCompany)
        this.setAttribute('role', this.dataCurrent.role.toString())
        this.setAttribute('password', this.dataCurrent.password)
        this.setAttribute('apiURL', this.dataCurrent.apiURL)
        this.setAttribute('isBlockedUser', this.dataCurrent.isBlockedUser)
        this.setAttribute('isVerifyEmail', this.dataCurrent.isVerifyEmail)
    }

    private setData() {
        if( this.user.attributes.idEmpresa !== undefined && this.user.attributes.role !== undefined){
            this.dataCurrent.role = this.user.attributes.role.toString() || ''
        }
        
        if( this.user.attributes.idEmpresa !== undefined ){
            this.dataCurrent.idEmpresa = this.user.attributes.idEmpresa.toString() || ''
        } else {
            this.dataCurrent.idEmpresa = ''
        }

        this.dataCurrent.password = this.pass

        // this.dataCurrent.registroPlataforma = this.user.attributes.registroPlataforma
        this.dataCurrent.serial = this.getSerialUnigest; //(this.user.attributes && this.user.attributes.serie) ? this.user.attributes.serie.toString() : ''
        this.dataCurrent.idEmpresa = (this.user.attributes && this.user.attributes.idEmpresa) ? this.user.attributes.idEmpresa.toString() : ''
        this.dataCurrent.isCreateCompany = (this.user.attributes && this.user.attributes.crearEmpresa) ? Boolean(this.user.attributes.crearEmpresa) : false
        // this.dataCurrent.password = this.dataCurrent.password || this.serialCurrent + '.123'
        this.dataCurrent.role = (this.user.attributes && this.user.attributes.role) ? this.user.attributes.role.toString() : ''
        this.dataCurrent.apiURL = (this.urlapi) ? this.urlapi.toString() : ''
        this.dataCurrent.isBlockedUser = (this.user.attributes && this.user.attributes.isBlockedUser !== null) ?  Boolean(this.user.attributes.isBlockedUser) : false
        this.dataCurrent.isVerifyEmail =(this.user.attributes && this.user.attributes.isVerifyEmail) ?  Boolean(this.user.attributes.isVerifyEmail) : false
        this.isNotAsignatedPassword = !(this.dataCurrent.password === '');
    }

    setNameCompanyFull(event: string){  
        this.dataCurrent.idEmpresa = (event).toUpperCase() + '_' + this.serialNumber
    }

    private processResult(dataResult: any): boolean {
        let result = false
        if(dataResult !== undefined) {

           if(dataResult.notificaciones !== undefined && dataResult.notificaciones.length > 0) {
                notify(`Se ha registrado correctamente.`, Colors.Info)
                this.setResult(dataResult.notificaciones, 'Procesos Realizados')
                result = true
            }

            if(dataResult.errores !== undefined && dataResult.errores.length > 0) {
                notify(`Habido errores ${dataResult.errores[0].toString()} `,Colors.Error)
                result = false
                this.setResult(dataResult.errores, 'Errores')
            }

            if(dataResult.advertencias !== undefined && dataResult.advertencias.length > 0) {
                notify(`Habido almenos una incidencia (${dataResult.advertencias.length} ) leve consultar resultados.`, Colors.Warning)
                this.setResult(dataResult.advertencias, 'Advertencias')
                result = true
            } 
            
        }
        return result
    }

    private setResult(data: Array<string>, title: string) {
            this.dataResultOperation = this.dataResultOperation.concat((this.dataResultOperation.length === 0 ? '': '\n') + title + ": ")
            data.forEach(e=>{
                this.dataResultOperation = this.dataResultOperation.concat((this.dataResultOperation.length === 0 ? '': '\n') + e)
            })
    }

    public onHidenResult() {
        this.dataResultOperation = ''
    }

    public async getCompanies(serialNumber: string, idUser: number) {  // public async getCompanies(serialNumber: string, idApiService: number) { 

        let result = []
        if(serialNumber  === undefined || serialNumber.length === 0 || this.dataCurrent.isCreateCompany){
            return []
        }

        try {
            if(!this.loading){
                this.$emit('loading', this.loading = true) 
                result = await api.getCompanyBySerialNumber(serialNumber, idUser)
            }   
        } catch (e) {
            throw new Error(_.get(e, 'response.data.message', e.message))
        } finally {
            this.$emit('loading', (this.loading = false)) //this.loading = false
        }

        if(result.password){
            this.pass = result.password;
            this.dataCurrent.password = this.pass;
        }
        if(result.apiUnigest){
            this.urlapi = result.apiUnigest;
            this.dataCurrent.apiURL = this.urlapi;
        }
        return result.companies
    }

    async onChageApisVersionSelect(){ // antes con id api -> async onChageApisVersionSelect(idApiService: number){

        try {
             this.companiesCurrent.length = 0
            this.dataCurrent.idEmpresa = ''
            const idUser = this.user.id;
            // Antes se mandaba el id de la api ahora el del usuario con esto obtenemos la api del grupo asignado a este.
            // └─> this.companiesCurrent = await this.getCompanies(this.serialCurrent, idApiSerivice)
            this.companiesCurrent = await this.getCompanies(this.serialCurrent, idUser) 
            if(!this.companiesCurrent || this.companiesCurrent.length < 1 && !this.dataCurrent.isCreateCompany ) {
                notify(`No se ha encontrado empresas en la bbdd con nº serie (${this.serialCurrent}), posiblemente no exista la BBDD.`  , Colors.Warning)
            }
        } catch (e) {
            this.companiesCurrent = new Array<string>()
            console.log(e.message);
            notify(`${e.message}}. Posiblemente no exista la BBDD.` , Colors.Error);
            // throw new Error(_.get(e, 'response.data.message', e.message))
        } finally {
            this.$emit('loading', (this.loading = false)) //this.loading = false
        }
    }

    // Devuelve el nº de serie
  private get getSerialUnigest() {
    let serial = '';
    if (this.user && this.user.groups && this.user.groups.length > 0) {
      serial = this.user.groups[0].attributes.SERIAL_NUMBER;
    }
    return serial;
  }
}
